/** @jsxImportSource theme-ui */
import PropTypes from "prop-types";
import { colors, typography } from "../../styles/theme";
import Icon from "./Icon";
import { Box, Text } from "theme-ui";

const chipStyle = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.5rem 1rem",
  borderRadius: "9999px",
};

const Chip = ({ label, type, leftIconName, leftIconColor, rightIconName, rightIconColor, customStyles, onClick }) => {
  const getTypeStyles = () => {
    switch (type) {
      case "subtle":
        return {
          backgroundColor: colors.primary100,
          ...typography.textMd500,
          color: colors.primaryMain,
          border: `1px solid ${colors.primaryMain}`,
          '&:hover': {
            backgroundColor: colors.primaryMain,
            color: colors.white,
          }
        };
      case "ghost":
        return {
          backgroundColor: colors.white,
          ...typography.textMd500,
          color: colors.primaryMain,
          border: `1px solid ${colors.primaryMain}`,
          '&:hover': {
            backgroundColor: colors.primary100,
            color: colors.primaryMain,
          }
        };
      case "solid":
      default:
        return {
          backgroundColor: colors.primaryMain,
          ...typography.textMd500,
          color: colors.white,
        };
    }
  };

  const textMarginStyles = {
    marginLeft: leftIconName ? '0.625rem' : '0',
    marginRight: rightIconName ? '0.625rem' : '0',
  };

  return (
    <Box sx={{ ...getTypeStyles(), ...chipStyle, ...customStyles }} onClick={onClick && onClick}>
      {leftIconName && <Icon name={leftIconName} color={leftIconColor} size={20} />}
      <Text sx={textMarginStyles}>{label}</Text>
      {rightIconName && <Icon name={rightIconName} color={rightIconColor} size={20} />}
    </Box>
  );
};

Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(["solid", "subtle", "ghost"]),
  leftIconName: PropTypes.string,
  leftIconColor: PropTypes.string,
  rightIconName: PropTypes.string,
  rightIconColor: PropTypes.string,
  customStyles: PropTypes.object,
  onClick: PropTypes.func,
};

Chip.defaultProps = {
  type: "solid",
  onClick: null,
  customStyles: {},
};

export default Chip;
